import React from 'react';
import classNames from 'classnames';
import { Icon } from '../Icon';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

export const FilterControl = ({ filterFields, filterCount, inline }) => {
  const hasOpenFilters = filterFields?.some(field => field.get('checked'));
  const hasRemainingFilters = filterFields?.some(
    field => !field.get('checked'),
  );
  return (
    filterFields &&
    (!inline || (hasOpenFilters && hasRemainingFilters)) && (
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          type="button"
          title="Add Filter"
          aria-label="Add Filter"
          className={classNames('btn btn-outline-primary', {
            'btn-sm': inline,
          })}
          disabled={!inline && hasOpenFilters}
        >
          <Icon name={inline ? 'plus' : 'filter'} />
          {!inline && typeof filterCount === 'number' && hasOpenFilters && (
            <span className="count-badge">{filterCount}</span>
          )}
        </DropdownToggle>
        <DropdownMenu>
          {filterFields.map(option => (
            <DropdownItem
              onClick={option.get('toggle')}
              key={option.get('name')}
              toggle={!option.get('checked')}
              disabled={option.get('checked')}
            >
              {option.get('checked') && <Icon name="check" md />}
              <span>{option.get('label')}</span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </UncontrolledDropdown>
    )
  );
};
